import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { animated, useSpring, } from "react-spring";
import { setVote, setVoted } from './redux/playerState';
import { updateVotingState, updateVoteComplete, updateTurn, } from './redux/gameState';
import './Drawcanvas.css';

function Timer(props) {
  const configState = useSelector((state) => state.configState);
  const playerState = useSelector((state) => state.playerState);
  const gameState = useSelector((state) => state.gameState);
  const [maxTime, setMaxTime] = useState(configState.time);
  const [timer, setTimer] = useState("--");
  const [socket, setSocket] = useState(props.socket);
  const [isDisabled, setDisabled] = useState(true);
  const id = useRef(null);
  const circleRef = useRef(null);
  const CIRCLE_SIZE = 250; // matches --size: 250px
  const STROKE_WIDTH = CIRCLE_SIZE / 2; // matches --stroke-width: 20px
  const RADIUS = (CIRCLE_SIZE - STROKE_WIDTH) / 2; // matches --radius calculation
  const CIRCUMFERENCE = RADIUS * 2 * Math.PI;

  useEffect(() => {
    if (circleRef.current) {
      const radius = circleRef.current.getAttribute('r');
      // Or, for the baseVal property of the SVGCircleElement interface:
      const radiusBaseVal = circleRef.current.r.baseVal.value;
    }
  }, []);
  useEffect(() => {
    setSocket(props.socket);
  }, []);

  const dispatch = useDispatch();

  const clear = () => {
    window.clearInterval(id.current)
  }
  useEffect(() => {
    if (props.started) {
      setMaxTime(maxTime);
      id.current = window.setInterval(() => {
        setTimer((time) => time - 1);
      }, 1000);

      circleApi.start({
        from: {
          strokeDashoffset: CIRCUMFERENCE, // Start empty
        },
        to: {
          strokeDashoffset: 0, // End full
        },
        config: {
          duration: maxTime * 1000,
          easing: t => t, // Linear easing for smooth countdown
        },
      });
      return () => clear();
    }
    else {
      setTimer(maxTime);
      // Reset circle
      circleApi.start({
        strokeDashoffset: CIRCUMFERENCE,
        immediate: true,
      });
    }
  }, [props.started]);

  useEffect(() => {
    setTimer(maxTime);
  }, [maxTime])

  useEffect(() => {
    if (timer === 0) {
      props.count(timer);
      setTimer(configState.time);
      clear();
    }
  }, [timer])

  useEffect(() => {
    setDisabled(true)
    if (playerState.myVote !== "") {
      setDisabled(false)
    }
  }, [playerState.myVote])

  useEffect(() => {
    if (playerState.voted) {
      setDisabled(true)
    }
  }, [playerState.voted])

  useEffect(() => {
    let turn = gameState.turn;
    if (gameState.players[turn].id == playerState.id) {
      setTimer(maxTime);
    }
    else {
      setTimer("--")
    }
  }, [gameState.turn])

  function vote(e, pid) {
    if (playerState.myVote === "") {
      return;
    }
    socket.emit("castVote", ({ pState: playerState, gState: gameState }));
    dispatch(setVoted(true));
  }

  useEffect(() => {
    if (!socket) return;
    socket.once("votingComplete", () => {
      dispatch(updateVoteComplete(false));
      dispatch(updateVotingState(false));
      dispatch(setVoted(false));
      dispatch(updateTurn(0));
      dispatch(setVote(""));
    });
    return () => {
      socket.off('votingComplete');
    };
  }, [socket]);

  const [circleAnim, circleApi] = useSpring(() => ({
    from: {
      strokeDashoffset: 0, // Start with full circle
      strokeDasharray: CIRCUMFERENCE, // Match the circumference
    },
  }));

  // TODO: Add text after voting indicating that you are now waiting for others to vote
  if (gameState.voting) {
    return (
      <div className="justify-center flex flex-1 w-full h-full aspect-square bg-white rounded-full" style={{ aspectRatio: "1 / 1" }}>
        <div className={(!isDisabled) ? "bg-white border-solid border-8 border-gray-700 rounded-full shadow-inner shadow-2xl w-full h-full items-center flex flex-wrap content-center justify-center voteBtn redVoteBtn glow" : "bg-white border-solid border-8 border-gray-700 rounded-full shadow-inner shadow-2xl w-full h-full items-center flex flex-wrap content-center justify-center voteBtn"}>
          <button className={(!isDisabled) ? "font-bold inline-block align-middle overflow-hidden" : "font-bold text-gray-700 inline-block align-middle disabled overflow-hidden"} disabled={isDisabled} onClick={(evt) => vote(evt, playerState.myVote)}><p>Vote!</p></button>
        </div>
      </div>
    );
  }
  else {
    return (
      <div className="justify-center flex flex-1 w-full h-full aspect-square relative" style={{ aspectRatio: "1 / 1" }}>
        <div className="absolute bg-white rounded-full inset-1 flex items-center justify-center">
          <div className="absolute w-full h-full p-6 flex items-center justify-center">
            <svg width="100%" height="100%" viewBox="0 0 250 250" className={"border-solid rounded-full circular-progress absolute"}>
              <animated.circle
                ref={circleRef}
                className="fg"
                r={RADIUS}
                cx={CIRCLE_SIZE / 2}
                cy={CIRCLE_SIZE / 2}
                fill="none"
                strokeWidth={STROKE_WIDTH}
                style={{
                  strokeDashoffset: circleAnim.strokeDashoffset,
                  strokeDasharray: CIRCUMFERENCE,
                  transform: "rotate(-90deg)",
                  transformOrigin: "center",
                  strokeLinecap: "butt", // Makes the stroke ends meet perfectly
                }}
              />
            </svg>
          </div>
          <div className="relative w-full h-full flex items-center justify-center">
            <div className='timer-outerBorder absolute inset-0 border-solid border-8 border-gray-900 rounded-full '>
              <div className=" timer-border absolute inset-0 -m-1 border-solid border-2 rounded-full shadow-inner shadow-2xl flex items-center justify-center ">
                <span className="font-bold text-gray-700 inline-block align-middle text-xl md:text-5xl xl:text-7xl overflow-hidden bg-none">{timer}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Timer;
